import React, { useState } from "react";
import ThemeToggle from "./ThemeToggle";
import LanguageSwitcher from "./LanguageSwitcher";
import { Github, Menu, X } from "lucide-react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation("translation");

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const scrollToSection = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navItems = [
    { id: "about", label: t("header.about") },
    { id: "skills", label: t("header.skills") },
    { id: "projects", label: t("header.projects") },
    { id: "certificates", label: t("header.certificates") },
    { id: "contact", label: t("header.contact") },
  ];

  return (
    <header className="relative border-b border-[var(--color-secondary)] px-6 py-4 flex justify-between items-center font-bold z-50">
      {/* Logo / Name */}
      <div className="text-xl text-[var(--color-text)] z-1000">
        <Link href="/">{t("header.name")}</Link>
      </div>

      {/* Desktop nav */}
      <nav className="hidden md:flex items-center gap-6 text-[var(--color-subtext)]">
        {navItems.map(({ id, label }) => (
          <Link
            key={id}
            href={`#${id}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(id);
            }}
            className="hover:text-[var(--color-highlight)]"
          >
            {label}
          </Link>
        ))}
      </nav>

      {/* Right actions */}
      <div className="hidden md:flex items-center gap-4">
        <ThemeToggle />
        <LanguageSwitcher />
        <a
          href="https://github.com/BA-S12"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Github />
        </a>
      </div>

      {/* Hamburger icon */}
      <button className="md:hidden z-50" onClick={toggleMenu}>
        {menuOpen ? <X /> : <Menu />}
      </button>

      {/* Mobile dropdown menu */}
      <div
        className={`fixed inset-0 bg-[var(--color-background)]/70 backdrop-blur-lg transform transition-all duration-300 ease-in-out ${
          menuOpen
            ? "translate-y-0 opacity-100"
            : "-translate-y-5 opacity-0 pointer-events-none"
        } md:hidden flex flex-col gap-4 p-6 pt-24 text-center text-[var(--color-text)]`}
      >
        {navItems.map(({ id, label }) => (
          <Link
            key={id}
            href={`#${id}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(id);
            }}
            className="hover:text-[var(--color-highlight)]"
          >
            {label}
          </Link>
        ))}

        <ThemeToggle />
        <LanguageSwitcher />
        <div className="flex justify-center gap-4 pt-4">
          <a
            href="https://github.com/BA-S12"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Github />
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
